(function () {
  'use strict';

  function initShowcase(inner) {
    var dots = Array.from(inner.querySelectorAll('.zelsu-hs__dot'));
    var cards = Array.from(inner.querySelectorAll('.zelsu-hs__product-card'));

    if (!dots.length || !cards.length) return;

    function activate(index) {
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.dataset.index, 10) === index);
      });
      cards.forEach(function (c) {
        c.classList.toggle('is-active', parseInt(c.dataset.index, 10) === index);
      });
    }

    dots.forEach(function (dot) {
      // Desktop: hover
      dot.addEventListener('mouseenter', function () {
        activate(parseInt(dot.dataset.index, 10));
      });
      // Mobile/touch: tap to activate
      dot.addEventListener('click', function () {
        activate(parseInt(dot.dataset.index, 10));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.zelsu-hs__inner').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when section or block is selected/added
  document.addEventListener('shopify:section:load', function (e) {
    var inner = e.target.querySelector('.zelsu-hs__inner');
    if (inner) initShowcase(inner);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var inner = e.target.closest('.zelsu-hs__inner');
    if (!inner) return;
    var index = parseInt(e.target.dataset.index, 10);
    if (!isNaN(index)) {
      var dots = Array.from(inner.querySelectorAll('.zelsu-hs__dot'));
      var cards = Array.from(inner.querySelectorAll('.zelsu-hs__product-card'));
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.dataset.index, 10) === index);
      });
      cards.forEach(function (c) {
        c.classList.toggle('is-active', parseInt(c.dataset.index, 10) === index);
      });
    }
  });
})();
